import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import { Box, Button, Stack, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import {
  Link as RouterLink,
  useLoaderData,
  useNavigation,
  useParams,
} from "react-router-dom";
import useDataGridPaging from "../../app/useDataGridPaging";
import { chatColumns } from "../chats/columns";
import { UserChatsData } from "./laoder";

/**
 * Kullanıcının hastane yazışmalarındaki (chats) mesajlarını listeler.
 * Satırdaki "Yazışma" bağlantısı mesajı hastane konuşması içinde gösterir.
 */
export default function UserChatsDataGrid() {
  const { id } = useParams();
  const { user, page } = useLoaderData() as UserChatsData;
  const navigation = useNavigation();
  const {
    handlePaginationModelChange,
    handleSortModelChange,
    paginationModel,
    sortModel,
    handleFilterChange,
    filterModel,
  } = useDataGridPaging(page);

  const title = user?.fullName || user?.userName || id;

  return (
    <Box sx={{ width: "100%" }}>
      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={1}
        sx={{
          alignItems: { sm: "center" },
          justifyContent: "space-between",
          mb: 2,
        }}
      >
        <Box>
          <Typography variant="h5" component="h1">
            Yazışmalar · {title}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {user?.email ? `${user.email} · ` : ""}
            {page.totalCount} mesaj
          </Typography>
        </Box>
        <Button
          component={RouterLink}
          to={`/users/${id}`}
          size="small"
          variant="outlined"
          startIcon={<PersonOutlineIcon />}
        >
          Kullanıcı Detayı
        </Button>
      </Stack>
      <DataGrid
        autoHeight
        sx={{ width: "100%" }}
        rows={page.data ?? []}
        getRowId={(row) => row.id}
        columns={chatColumns}
        getRowClassName={(params) =>
          params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
        }
        paginationModel={paginationModel}
        loading={navigation.state === "loading"}
        rowCount={page.totalCount}
        paginationMode="server"
        sortingMode="server"
        filterMode="server"
        filterModel={filterModel}
        pageSizeOptions={[10, 20, 50, 100]}
        disableColumnResize
        onSortModelChange={handleSortModelChange}
        onPaginationModelChange={handlePaginationModelChange}
        sortModel={sortModel}
        onFilterModelChange={handleFilterChange}
        density="compact"
        localeText={{ noRowsLabel: "Bu kullanıcının yazışma mesajı yok." }}
        slotProps={{
          filterPanel: {
            filterFormProps: {
              logicOperatorInputProps: {
                variant: "outlined",
                size: "small",
              },
              columnInputProps: {
                variant: "outlined",
                size: "small",
                sx: { mt: "auto" },
              },
              operatorInputProps: {
                variant: "outlined",
                size: "small",
                sx: { mt: "auto" },
              },
              valueInputProps: {
                InputComponentProps: {
                  variant: "outlined",
                  size: "small",
                },
              },
            },
          },
        }}
      />
    </Box>
  );
}
